var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilter1 = function SvgFilter1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.932 5.388c.128.272.075.504-.16.696l-5.593 4.902v7.378c0 .278-.148.474-.443.586a.888.888 0 0 1-.284.05.723.723 0 0 1-.51-.189l-2.905-2.545a.577.577 0 0 1-.216-.448v-4.832L4.227 6.084c-.234-.192-.287-.424-.159-.696.129-.259.352-.388.67-.388h14.524c.318 0 .541.13.67.388Z",
    fill: "#666"
  })));
};
export default SvgFilter1;